<div class="container-fluid">
  <div class="row p-0 justify-content-center">
    <div
      class="card col-11 col-md-5 col-lg-4 col-xl-3 m-1 p-0"
      style="width: auto"
      *ngFor="let experiencia of experiencias"
    >
      <div class="card-header d-flex justify-content-center">
        <img
          [src]="experiencia.DES_IMG"
          class="card-img-top m-0 p-3"
          [alt]="experiencia.DES_NOMBRE_EMPRESA + ' imagen'"
          style="width: 90%"
        />
      </div>

      <div class="card-body">
        <h5 class="card-title">
          {{ experiencia.DES_NOMBRE_EMPRESA }} |
          {{ experiencia.FECHA_INICIO }}-{{ experiencia.FECHA_FIN }}
        </h5>
        <p class="card-text">
          {{ experiencia.DES_NOMBRE_PUESTO }}
        </p>
        <p class="card-text">
          {{ experiencia.DES_PUESTO }}
        </p>
      </div>
      <div class="card-footer m-0 p-0">
        <div class="row col-12 m-0 p-0">
          <img
            class="col-auto m-0 mt-1 mb-1"
            style="width: 73px; height: auto"
            *ngFor="let tecnologia of experiencia.TECNOLOGIAS"
            [src]="tecnologia.DES_NOMBRE"
          />
        </div>
      </div>
    </div>
  </div>
</div>
